import { createContext, useContext } from 'react';

import type { ResourceActivityResourceType, ResourceVersionChange } from '@/types';

export interface ResourceRoutePreviewValue {
    activityId: string;
    changes: ResourceVersionChange[];
    createdAt: string;
    readOnly: true;
    resourceId: string;
    resourceType: ResourceActivityResourceType;
    routeResource?: { resourceType: string; resourceId: string };
    reportId?: string;
    snapshot: Record<string, unknown>;
}

export const ResourceRoutePreviewContext = createContext<ResourceRoutePreviewValue | null>(null);

export const useResourceRoutePreview = (): ResourceRoutePreviewValue | null => useContext(ResourceRoutePreviewContext);

export const matchesResourceRoutePreview = (
    preview: ResourceRoutePreviewValue | null,
    resourceType: string,
    resourceId?: string | null,
): boolean =>
    Boolean(
        preview &&
        resourceId &&
        [preview, preview.routeResource].some(
            (resource) =>
                resource?.resourceId === resourceId &&
                (resource.resourceType === resourceType || resource.resourceType === `${resourceType}s`),
        ),
    );
